module.exports = __webpack_public_path__ + "static/objekti-4f2f87d8c02d0066b93dd6f4db8ab941.png";